const AB_TESTS = {
  ALL: "/ab-tests",
  UPDATE: "/ab-tests",
}

const ALERTS = {
  ALL: "/alerts",
  MUTE: "/alert/mute",
  UNMUTE: "/alert/unmute",
}

const BALANCE_RECOMMENDATIONS = {
  ALL: "/balance-recommendations",
}

const BALANCES = {
  ACTUAL: "/balances/groups/actual",
  HISTORY: "/balances/groups/history",
  DELETE: "/balances/groups",
  UPDATE: "/balances/groups/update",
}

const BANKS = {
  ALL: "/banks",
  CREATE: "/banks/create",
  DELETE: "/banks",
  UPDATE: "/banks",
}

const COMMON = {
  BANKS: "/common_info/banks",
  CHANNELS: "/common_info/channels",
  COUNTRIES: "/common_info/countries",
  DEPOSIT_STATUSES: "/common_info/deposit-statuses",
  ORDER_LOG_TYPES: "/common_info/order-log-types",
  ORDER_TAGS: "/common_info/order-tags",
  PROCESSORS: "/common_info/processors",
  SYSTEMS: "/common_info/systems",
  USERS: "/common_info/users",
  VWO_VARIATIONS: "/common_info/vwo-variations",
  CHARGEBACK_CATEGORIES: "/common_info/chargeback-categories",
}

const CURRENCIES = {
  ALL: "/currencies",
}

const CUSTOMER = {
  DETAILS: "/customer/details",
  FIND: "/customers/find",
  FREE_DEPOSIT_LIMIT_LOGS: "/customer/free-deposit-limit-logs",
  ORDERS: "/customer/orders",
  PREPARE_ORDERS_DOWNLOAD: "/customer/orders/download",
  PROCESS: "/customer/process",
  PURSES: "/customer/purses",
  QUEUE: "/customer/withdraw-queue",
  SESSIONS: "/customer/sessions",
  SYSTEMS: "/customer/personal-settings",
  TURNOVER: "/customer/turnover",
  UPDATE_PURSE: "/customer/purses",
  WIDGET: "/customer/widget",
  WIDGET_SYSTEMS: "/customer/widget/get-systems",
}

const CUSTOM_RATES = {
  ALL: "/custom-rates",
  UPDATE: "/custom-rates",
}

const DAILY_PASSABILITY_MONITORS = {
  ALL: "/passability_monitors",
  CREATE: "/passability_monitors/create",
  UPDATE: "/passability_monitors",
  SLICES: "/passability_monitors/slices",
  ON_OFF_SLICE: "/passability_monitors/slices",
}

const DISPUTES = {
  ALL: "/disputes",
  UPDATE: "/disputes",
  DOWNLOAD: "/disputes/download",
}

const FREE_DEPOSIT_LIMITS = {
  ALL: "/free-deposit-limits",
  CREATE: "/free-deposit-limits/create",
  GET: "/free-deposit-limits/get",
  UPDATE: "/free-deposit-limits",
}

const LOGS = {
  ALL: "/logs",
}

const MONITOR_VOLUMES = {
  ALL: "/monitor_volumes",
  CREATE: "/monitor_volumes/create",
  UPDATE: "/monitor_volumes",
}

const NOVOBANKA_REGISTRY = {
  DOWNLOAD: "/novabanka-registry/download",
  LIST: "/novabanka-registry",
  CREATE: "/novabanka-registry/new",
}

const SERBIA_BANK_REGISTRY = {
  DOWNLOAD: "/serbia-bank-registry/download",
  LIST: "/serbia-bank-registry",
  CREATE: "/serbia-bank-registry/new",
}

const ORDER = {
  ACTION_LOGS: "/order/action-logs",
  COMMENT: "/order-comments/create",
  PREPARE_DOWNLOAD: "/orders/download",
  EXTERNAL_OPERATIONS: "/order/external-operations",
  FIND: "/order/find",
  GET: "/order",
  ALL: "/orders",
  OPERATIONS: "/order/operations",
  PROCESS: "/order/process",
  SET_STATUS: "/order/update-status",
  STATUS_HISTORY: "/order/status-history",
  SUBTYPE_HISTORY: "/order/subtype-history",
  TECH_LOGS: "/order/logs",
}

const ORDER_EXPORTS = {
  ALL: "/order-exports",
  DOWNLOAD: "/order-exports/download",
  CANCEL: "/order-exports/cancel",
}

const ORDER_FAILURE_CODES = {
  ALL: "/order-failure-codes",
  CREATE: "/order-failure-codes/create",
  DELETE: "/order-failure-codes",
  UPDATE: "/order-failure-codes",
  DOWNLOAD: "/order-failure-codes/download",
}

const ORDER_FAILURE_KINDS = {
  ALL: "/order-failure-kinds",
  CREATE: "/order-failure-kinds/create",
  DELETE: "/order-failure-kinds",
  UPDATE: "/order-failure-kinds",
  BULK_UPDATE: "/order-failure-kinds/bulk",
  DOWNLOAD: "/order-failure-kinds/download",
}

const ORDERS = {
  HUNG_WITHDRAWS: "/hung-withdraws",
  QUEUE: "/withdraw-queue",
}

const PAYMENT_LOOPS = {
  ALL: "/payment-loops",
  CREATE: "/payment-loops/new",
  DELETE: "/payment-loops",
  UPDATE: "/payment-loops",
}

const PROCESSOR_ACCOUNTS = {
  ALL: "/processor-accounts",
  CREATE: "/processor-accounts/new",
  DUPLICATE: "/processor-accounts/duplicate",
  GET: "/processor-accounts/get",
  UPDATE: "/processor-accounts",
}

const PROCESSOR_CALLBACKS = {
  ALL: "/processor-callbacks",
  GET: "/processor-callback",
  MAKE: "/processor-callback/make",
  RETRY: "/processor-callback/retry",
}

const PROCESSOR_FEES = {
  ALL: "/processor-fees",
}

const PROCESSORS = {
  ALL: "/processors",
  UPDATE: "/processors",
}

const PROJECTS = {
  ALL: "/projects",
  CREATE: "/projects/create",
  UPDATE: "/projects",
}

const REFUNDS = "/refunds"
const REFUNDS_DOWNLOAD = "/refunds/download"

const REPORTS = {
  BANNED_PURSES: "/saved-purse-bans",
  BANNED_PURSES_DOWNLOAD: "/saved-purse-bans/download",
  CUSTOMERS_TURNOVER: "/reports/customers-turnover",
  DEPOSIT_PASSABILITY: "/reports/deposit-passability",
  DEPOSIT_PASSABILITY_V2: "/reports/deposit-passability-v2",
  DEPOSIT_PASSABILITY_CUSTOMERS: "/reports/deposit-passability/customers",
  FEES: "/reports/fee",
  GLOBAL_ORDERS: "/reports/global-orders-report",
  PROCESSOR_EXTERNAL_ACTIONS: "/reports/processor-external-actions-report",
  TRAFFIC_DISTRIBUTION: "/reports/traffic-distribution",
  TRANSACTIONS: "/reports/transactions",
  TRANSITION_HISTORY: "/reports/withdraw-transition-history",
  WITHDRAW_PASSABILITY: "/reports/withdraw-passability",
}

const RULE_ACTIONS = {
  CREATE: "/rule-actions/new",
  DELETE: "/rule-actions",
  DUPLICATE: "/rule-actions/duplicate",
  GET: "/rule-actions/get",
  MOVE_DOWN: "/rule-actions/move-down",
  MOVE_UP: "/rule-actions/move-up",
  UPDATE: "/rule-actions",
}

const RULE_SEGMENTS = {
  ALL: "/rule-segments",
  CREATE: "/rule-segments/new",
  DELETE: "/rule-segments",
  DUPLICATE: "/rule-segments/duplicate",
  GET: "/rule-segments/get",
  MOVE_DOWN: "/rule-segments/move-down",
  MOVE_UP: "/rule-segments/move-up",
  SCHEMA: "/rule-segments/schema",
  SHOW: "/rule-segment",
  UPDATE: "/rule-segments",
}

const SETTINGS = {
  MANIFEST: "/manifest",
}

const SYSTEM_SETTINGS = {
  ALL: "/systems",
  UPDATE: "/systems",
}

const USER = {
  ACTIVITY: "/track-user-activity",
  AUTHORIZE: "/authorize",
}

const PRESETS = {
  ALL: "/presets",
  CREATE: "/presets/create",
  DELETE: "/presets",
  UPDATE: "/presets",
}

const WIDGET = {
  INFO: "/widget/get-cashier-info",
  ONE_CLICK: "/widget/get-oneclick-info",
  PROJECT_SYSTEMS: "/widget/get-project-systems",
  SYSTEMS: "/widget/get-systems",
}

export default {
  AB_TESTS,
  ALERTS,
  BALANCE_RECOMMENDATIONS,
  BALANCES,
  BANKS,
  COMMON,
  CURRENCIES,
  CUSTOMER,
  CUSTOM_RATES,
  DAILY_PASSABILITY_MONITORS,
  DISPUTES,
  FREE_DEPOSIT_LIMITS,
  LOGS,
  MONITOR_VOLUMES,
  NOVOBANKA_REGISTRY,
  SERBIA_BANK_REGISTRY,
  ORDER,
  ORDER_EXPORTS,
  ORDER_FAILURE_CODES,
  ORDER_FAILURE_KINDS,
  ORDERS,
  PAYMENT_LOOPS,
  PROCESSOR_ACCOUNTS,
  PROCESSOR_CALLBACKS,
  PROCESSOR_FEES,
  PROCESSORS,
  PROJECTS,
  REFUNDS,
  REFUNDS_DOWNLOAD,
  REPORTS,
  RULE_ACTIONS,
  RULE_SEGMENTS,
  SETTINGS,
  SYSTEM_SETTINGS,
  USER,
  PRESETS,
  WIDGET,
}
